<template>
    <setting-group :settings="settings" :columns="columns"/>
</template>

<script>
import SettingGroup from "./SettingGroup"
import cloneDeep from 'lodash/cloneDeep'
import sortSettings from "../../functions/sortSettings";

export default {
    components: {
        SettingGroup,
    },

    data() {
        return {
            columns: 4,
        }
    },

    computed: {
        settings() {
            return sortSettings(
                cloneDeep(this.$store.getters.settings),
                [
                    'Fakturering',
                    'Fakturering - Domestic',
                    'Fakturering - EU',
                    'Fakturering - Abroad',
                    'Fakturering - Domestic exempt VAT'
                ],
                this.columns
            )
        }
    },

    created() {
        this.$store.dispatch('loadSettings')
    },
}
</script>
